import FeaturedItems from "./FeaturedItems";
import compose from "recompose/compose";
import when from "recompose/branch";
import mapProps from "recompose/mapProps";
import renderNothing from "recompose/renderNothing";

export const enhance = compose(
  when((props) => !props.items.length, renderNothing),
  mapProps((props) => ({
    title: props.title,
    items: props.items,
  }))
);

export default enhance(FeaturedItems);
